import React, { useState } from "react";
import { LuTrash2 as Trash2, LuEye as Eye } from "react-icons/lu";
import { Link } from "react-router-dom";
import { DeletePostModel } from "./delete-post";
import { TAALY } from "src/utils/constants.util";

// Action Buttons Component
type ActionButtonsProps = {
  userId: string;
  postId: string;
};

export const ActionButtons = ({ userId, postId }: ActionButtonsProps) => {
  const [openDelete, setDeleteModel] = useState(false);

  return (
    <div className="flex items-center gap-2 opacity-80 group-hover:opacity-100 transition-opacity">
      {userId !== TAALY ? (
        <Link
          to={`/users/${userId}`}
          className="inline-flex items-center justify-center gap-2 px-4 py-2.5 
           rounded-xl text-sm font-semibold text-blue-600 
           bg-blue-50 border border-blue-100 
           hover:bg-blue-100 hover:text-blue-700 hover:border-blue-200
           active:bg-blue-200 transition-all duration-200
           focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 
           disabled:pointer-events-none disabled:opacity-50 no-underline
           hover:shadow-md hover:-translate-y-0.5"
        >
          <Eye className="h-4 w-4" />
          View user
        </Link>
      ) : null}
      <button
        className="inline-flex items-center justify-center gap-2 px-4 py-2.5 
           rounded-xl text-sm font-semibold text-red-600 
           bg-red-50 border border-red-100 
           hover:bg-red-100 hover:text-red-700 hover:border-red-200
           active:bg-red-200 transition-all duration-200
           focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400 focus-visible:ring-offset-2 
           disabled:pointer-events-none disabled:opacity-50
           hover:shadow-md hover:-translate-y-0.5
           cursor-pointer"
        onClick={() => setDeleteModel(true)}
      >
        <Trash2 />
        Delete
      </button>
      {openDelete && <DeletePostModel id={postId} handleClose={() => setDeleteModel(false)} />}
    </div>
  );
};
